import { createSelector } from 'reselect';

import type { StoreType } from '.';

const selectPublishers = (state: StoreType) => state.publishers.data;

export const selectCoursesPublishers = createSelector([selectPublishers], (publishers) =>
	publishers ? publishers.filter((publisher) => publisher.scope?.includes('courses') ?? true) : []
);

export const selectDocumentsPublishers = createSelector([selectPublishers], (publishers) =>
	publishers ? publishers.filter((publisher) => publisher.scope?.includes('documents') ?? true) : []
);

export const selectPublisherLoadingStatus = (state: StoreType) => state.publishers.status;
